import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const handleUpdateEvent = createAsyncThunk("Events/handleUpdateEvent", async (data, thunkAPI) => {
    let eventId=data.id;
    delete data.id
  try {
    const resp = await axios.put(`${process.env.REACT_APP_BASE_URL}api/events-alerts-v2/event/${eventId}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return {...data,id:eventId};
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
